/**
 * VerificationBadge - 认证徽章组件
 * 用于展示GI认证、有机认证等信息
 */

import React from 'react';
import { CheckOne, Shield } from '@icon-park/react';
import './VerificationBadge.css';

function VerificationBadge({ 
  type = 'gi', // 'gi' | 'organic' | 'green' | 'custom'
  label,
  certified = true,
  certNumber,
  certDate,
  certOrg,
  icon,
  customColor
}) {
  // 预设类型配置
  const typeConfig = {
    gi: {
      label: 'GI地理标志',
      color: 'var(--color-primary)',
      bgColor: 'var(--color-primary-light)',
      icon: <Shield theme="outline" size={20} />
    },
    organic: {
      label: '有机认证',
      color: 'var(--color-primary)',
      bgColor: 'var(--color-primary-light)',
      icon: <CheckOne theme="outline" size={20} />
    },
    green: {
      label: '绿色食品',
      color: 'var(--color-primary)',
      bgColor: 'var(--color-primary-light)',
      icon: <CheckOne theme="outline" size={20} />
    },
    custom: {
      label: label || '认证标识',
      color: customColor || 'var(--color-primary)',
      bgColor: 'var(--color-primary-light)',
      icon: icon || <CheckOne theme="outline" size={20} />
    }
  };

  const config = typeConfig[type] || typeConfig.custom;

  return (
    <div 
      className="verification-badge-container"
      style={{ 
        borderColor: config.color,
        backgroundColor: config.bgColor 
      }}
    >
      {/* 徽章头部 */}
      <div className="verification-badge-header">
        <div className="verification-icon" style={{ color: config.color }}>
          {config.icon}
        </div>
        <div className="verification-title">
          {config.label}
        </div>
        {certified && (
          <div className="verification-status verified">
            <CheckOne theme="outline" size={14} />
            已认证
          </div>
        )}
      </div>

      {/* 认证详情 */}
      {certified && (certNumber || certDate || certOrg) && (
        <div className="verification-details">
          {certNumber && (
            <div className="detail-item">
              <span className="detail-label">证书编号：</span>
              <span className="detail-value">{certNumber}</span>
            </div>
          )}
          {certDate && (
            <div className="detail-item">
              <span className="detail-label">认证日期：</span>
              <span className="detail-value">{certDate}</span>
            </div>
          )}
          {certOrg && (
            <div className="detail-item">
              <span className="detail-label">认证机构：</span>
              <span className="detail-value">{certOrg}</span>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default VerificationBadge;
